export class EngagementWallChartSummary {
    Category: string | null;
    Start: number | null;
    End: number | null;
    Color: string | null;
}
